module.exports = __webpack_public_path__ + "static/media/Group276.cd0e0f65.png";